module.exports = __webpack_public_path__ + "img/d79a0f31845c76335e3e733f0d01b0c3.png";